module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Map/Location-arrow-e46192ceb3f444a5d6a13cefbdac15f8.svg";